import { NgModule } from '@angular/core';

import { SidebarComponent } from './component/sidebar/sidebar.component';
import { TabbarComponent } from './component/tabbar/tabbar.component';

import { HomeComponent } from './pages/home/home.component';


import { ChileComponent } from './pages/chile/chile.component'
import { TypeService } from './service/lcontype/type.service';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { IconsProviderModule } from './icons-provider.module';
import { NgZorroAntdModule, NZ_I18N, en_US, zh_CN } from 'ng-zorro-antd';
import { ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

import { TestWeiyunComponent } from './test-weiyun.component';
import { TestWeiyunRoutingModule } from './test-weiyun-roution.module'

@NgModule({
  declarations: [
    TestWeiyunComponent,
    HomeComponent,
    SidebarComponent,
    TabbarComponent,
    ChileComponent
  ],
  imports: [
    TestWeiyunRoutingModule,
    BrowserModule,
    IconsProviderModule,
    NgZorroAntdModule,
    FormsModule,
    HttpClientModule,
    NzIconModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzPopoverModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: zh_CN },
    TypeService,
  ],
  exports: [TestWeiyunComponent],
  entryComponents: [
    ChileComponent
  ]
})
export class TestWeiyunModule { }
